module.exports = __webpack_public_path__ + "img/header-memoireRingsBudgetHigh.e389f8c.jpg";